import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/AuthContext';
import Logo from './Logo';
import LanguageToggle from './LanguageToggle';
import ThemeToggle from './ThemeToggle';
import Icon from './Icon';

export default function PublicNav() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`nav ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <Logo />
        <div className="nav-links">
          <a href="/#features" className="link">{t('nav.features')}</a>
          <a href="/#grow" className="link">{t('nav.grow')}</a>
          <a href="/#how" className="link">{t('nav.how')}</a>
          <a href="/#pricing" className="link">{t('nav.pricing')}</a>
          <ThemeToggle />
          <LanguageToggle />
          {user ? (
            <Link to="/dashboard" className="btn btn-sm">
              {t('nav.dashboard')} <Icon name="arrow" size={14} />
            </Link>
          ) : (
            <>
              <Link to="/login" className="link">{t('nav.login')}</Link>
              <Link to="/register" className="btn btn-sm">{t('nav.register')}</Link>
            </>
          )}
          <Link to="/yayincilar" className="btn btn-ghost btn-sm">{t('nav.publisher_cta')}</Link>
        </div>
      </div>
    </header>
  );
}
